import { useState } from '#app';
import {
  plausibleOptedOut,
  PLAUSIBLE_OPTOUT_COOKIE
} from '~/utils/plausible-privacy';
export function usePlausiblePrivacy() {
  const optedOut = useState('privacy:plausible-optout', () => false);
  function sync() {
    if (import.meta.client) optedOut.value = plausibleOptedOut(window);
  }
  function save(value) {
    if (!import.meta.client) return;
    optedOut.value = value === true;
    window.__idmanifyPlausibleOptOut = optedOut.value;
    try {
      document.cookie = `${PLAUSIBLE_OPTOUT_COOKIE}=${value ? '1' : '0'}; Path=/; Max-Age=31536000; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
    } catch {
      /* The in-memory objection remains active if cookies are blocked. */
    }
    if (value) window.__idmanifyPlausible?.revoke();
    window.dispatchEvent(new Event('idmanify:plausible-preference'));
    try {
      const channel = new BroadcastChannel('idmanify:plausible-preference');
      channel.postMessage(optedOut.value);
      channel.close();
    } catch {
      /* Every event and focus also rechecks the preference cookie. */
    }
  }
  return { optedOut, sync, save };
}
